<template>
  <div class="card-block">
    <form autocomplete="off" role="presentation"  style="background-color: #f9f9f9; padding: 14px; border-radius: 5px; border: solid 1px #efefef;">
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <strong><i class="fas fa-tasks"></i> {{$lang.EmployeeBoard.BoardHistory.Title}}</strong>
          <div class="edit-board"><a href="javascript:void(0);" @click="onCloseHistory"><i class="fas fa-times-circle"></i>&nbsp;{{$lang.EmployeeBoard.BoardHistory.Close}}</a></div>
        </div>
        <div class="col-md-12 pt-4">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="thead-default">
                <tr>
                  <th class="text-center"><span>{{$lang.Common.DataTable.ActionDate}}</span></th>
                  <th class="text-center"><span>IP</span></th>
                  <th class="text-center"><span>{{$lang.EmployeeBoard.BoardHistory.DataTable.Place}}</span></th>
                  <th class="text-center"><span>{{$lang.Common.DataTable.AccountAction}}</span></th>
                  <th class="text-center"><span>{{$lang.Common.DataTable.Actions}}</span></th>
                  <th class="text-center"><span>{{$lang.EmployeeBoard.BoardHistory.DataTable.Reason}}</span></th>
                </tr>
              </thead>
              <tbody v-if="showDataHistory">
                <tr v-for="(obj, index) in this.dataHistory" v-bind:key="index">
                  <td class="text-center">{{obj.dataCriacaoFormated}}</td>
                  <td class="text-center">{{obj.ip}}</td>
                  <td class="text-center"><a :href="getUrl(obj.latitude, obj.longitude)" target="_blank"><strong>{{$lang.Common.Show}}</strong></a></td>
                  <td class="text-center">{{obj.autor ? obj.autor.nome : ''}}</td>
                  <td class="text-center">{{obj.acao}}</td>
                  <td class="text-center">{{obj.observacaoMotivo ? obj.observacaoMotivo : '-'}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">{{$lang.Common.DataTable.NoRecordsFound}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
const googleMapUrl = 'https://maps.google.com/maps?f=q&source=s_q&hl=pt_BR&q='

export default {
  name: 'BoardHistory',
  props: {
    value: Array
  },
  computed: {
    dataHistory () {
      let result = []
      if (this.value) {
        result = this.value
      }
      return result
    },
    showDataHistory () {
      let result = false
      if (this.value && this.value.length > 0) {
        result = true
      }
      return result
    }
  },
  methods: {
    onCloseHistory () {
      this.$emit('CloseHistory')
    },
    getUrl (latitude, longitude) {
      return googleMapUrl + latitude + ',' + longitude
    }
  }
}
</script>
<style scoped>
.edit-board {
  display: block;
  position: absolute;
  text-align: right;
  width: 100%;
  right: 15px;
  top: -1px;
}
.edit-board i {
  font-size: 12px;
}
table tbody tr td {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/components/history/boardhistory.vue